import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GoToPageService } from '../../services/go-to-page.service';
/**
 * Go To Page Component
 */
let GoToPageComponent = class GoToPageComponent {
    constructor(router, activated, goToService) {
        this.router = router;
        this.activated = activated;
        this.goToService = goToService;
        this.activated.params.subscribe((params) => {
            const type = params['orderType'];
            const currency = params['currency'];
            const mean_of_payment = params['mop'];
            if (type && currency) {
                if (type !== 'choose') {
                    if (mean_of_payment) {
                        this.goToService.goTo(type, currency, mean_of_payment);
                    }
                    else {
                        this.goToService.goTo(type, currency, null);
                    }
                }
            }
            else {
                this.router.navigateByUrl('/');
            }
        });
    }
    ngOnInit() {
    }
};
GoToPageComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: GoToPageService }
];
GoToPageComponent = __decorate([
    Component({
        selector: 'ecd-go-to',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./go-to-page.component.html")).default
    })
], GoToPageComponent);
export { GoToPageComponent };
